import './baseAxios'
import instanceModule from './instance'
import configModule from './config'

export const instance = instanceModule
export const config = configModule

export default instance